import { Button } from '@design-system/components/button/button';
import { SearchInput } from '@design-system/components/searchinput';
import { SmartTable } from '@client/new/components/SmartTable/SmartTable';
import { DuplicateWorkoutDialog } from '@client/new/features/workout-duplicate';
import { useScheduledWorkouts } from './components/useScheduledWorkouts';
import { WorkoutsPage } from './components/WorkoutsPage';
import * as styles from './components/workoutsListPage.css';

export function ScheduledWorkoutsPage(props) {
  const {
    isLoading,
    creator,
    isEmpty,
    table,
    search,
    pagination,
    duplicateDialog,
  } = useScheduledWorkouts(props.params.influencerId);

  return (
    <WorkoutsPage isLoading={isLoading} creator={creator}>
      {!isEmpty && (
        <div className={styles.search}>
          <SearchInput
            value={search.value}
            placeholder="Search workout"
            onChange={(e) => search.onChange(e.target.value)}
            onClear={search.onClear}
          />
        </div>
      )}
      <section className={styles.listSection}>
        {isEmpty ? 'This list is empty' : <SmartTable {...table} />}
      </section>
      {(pagination.hasPrevPage || pagination.hasNextPage) && (
        <div className={styles.pagination}>
          <Button
            variant="outlined"
            disabled={!pagination.hasPrevPage}
            onClick={pagination.goPrev}
          >
            Previous
          </Button>
          <Button
            variant="outlined"
            disabled={!pagination.hasNextPage}
            onClick={pagination.goNext}
          >
            Next
          </Button>
        </div>
      )}
      {duplicateDialog ? <DuplicateWorkoutDialog {...duplicateDialog} /> : null}
    </WorkoutsPage>
  );
}
